import { Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';

@Component({
  templateUrl: './manager-inspection-list.menu.html',
  standalone: false
})
export class ManagerInspectionListMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
  }
}
